import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import Skeleton from "react-loading-skeleton";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "react-loading-skeleton/dist/skeleton.css";
import "../style/heroBanner.css";
import { getherobanner } from "../service/herobanner.service";
import { Link } from "react-router-dom";
import { getHomeUrl } from "../../../utils/url.utils";

const Herobanner = React.memo(() => {
  const [topBanners, setTopBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deviceType, setDeviceType] = useState(
    window.innerWidth <= 768 ? "mobile" : "desktop"
  );
  useEffect(() => {
    fetchHeroBanner();
    const handleResize = () => {
      setDeviceType(window.innerWidth <= 768 ? "mobile" : "desktop");
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchHeroBanner = async () => {
    try {
      setLoading(true);
      const data = await getherobanner();
      setTopBanners(data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getImage = useCallback(
    (media = []) => {
      return (
        media.find((item) => item.deviceType === deviceType) ||
        media.find((item) => item.deviceType === "desktop") ||
        media.find((item) => item.deviceType === "mobile") ||
        {}
      );
    },
    [deviceType]
  );

  const bannerSlides = useMemo(() => {
    return topBanners.map((banner) => {
      const image = getImage(banner.media);
      return (
        <SwiperSlide key={banner.id}>
          <Link to={getHomeUrl(banner.buttonUrl)}>
          <img
            src={image.image}
            alt={image.altText || banner.title}
            loading="lazy"
            className="img-fluid w-100 mobile-banner"
            style={{
              width: "100%",
              objectFit: "cover",
            }}
          />
           </Link>
        </SwiperSlide>
      );
    });
  }, [topBanners, getImage]);
  if (!loading && !topBanners?.length) return null;

  return (
    <section className="Hero-Slider">
      <div className="banner-slider position-relative">
        <div className="swiper-button-prev custom-nav"></div>
        <div className="swiper-button-next custom-nav"></div>
        {loading ? (
          <Skeleton height={400} width="100%" />
        ) : (
          <Swiper
            modules={[Navigation, Autoplay, Pagination]}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            pagination={{
              clickable: true,
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop={true}
            spaceBetween={10}
          >
            {bannerSlides}
          </Swiper>
        )}
      </div>
    </section>
  );
});
Herobanner.displayName = "Herobanner";
export default Herobanner;